export const GET_ELIGIBLE_LINE_COUNT_REQUEST = 'GET_ELIGIBLE_LINE_COUNT_REQUEST';
export const GET_ELIGIBLE_LINE_COUNT_SUCCESS = 'GET_ELIGIBLE_LINE_COUNT_SUCCESS';
export const GET_ELIGIBLE_LINE_COUNT_FAILURE = 'GET_ELIGIBLE_LINE_COUNT_FAILURE';

export const ORDER_PAYMENT_DETAILS_REQUEST = 'ORDER_PAYMENT_DETAILS_REQUEST';
export const ORDER_PAYMENT_DETAILS_SUCCESS = 'ORDER_PAYMENT_DETAILS_SUCCESS';
export const ORDER_PAYMENT_DETAILS_ERROR = 'ORDER_PAYMENT_DETAILS_ERROR';

export const SUBMIT_ORDER_REQUEST = 'SUBMIT_ORDER_REQUEST';
export const SUBMIT_ORDER_SUCCESS = 'SUBMIT_ORDER_SUCCESS';
export const SUBMIT_ORDER_ERROR = 'SUBMIT_ORDER_ERROR';

export const ORDER_GET_ORDER_DETAILS_REQUEST = 'ORDER_GET_ORDER_DETAILS_REQUEST';
export const ORDER_GET_ORDER_DETAILS_SUCCESS = 'ORDER_GET_ORDER_DETAILS_SUCCESS';
export const ORDER_GET_ORDER_DETAILS_FAILURE = 'ORDER_GET_ORDER_DETAILS_FAILURE';

export const ORDER_CREATE_NEW_ORDER_REQUEST = 'ORDER_CREATE_NEW_ORDER_REQUEST';
export const ORDER_CREATE_NEW_ORDER_STORE = 'ORDER_CREATE_NEW_ORDER_STORE';

export const ORDER_SAVE_TO_CART_REQUEST = 'ORDER_SAVE_TO_CART_REQUEST';
export const ORDER_SAVE_TO_CART_SUCCESS = 'ORDER_SAVE_TO_CART_SUCCESS';
export const ORDER_SAVE_TO_CART_FAILURE = 'ORDER_SAVE_TO_CART_FAILURE';

export const SET_NO_OF_LINE_REQUEST = 'SET_NO_OF_LINE_REQUEST';

export const GET_DIST_CARD_PROFILE_REQUEST = 'GET_DIST_CARD_PROFILE_REQUEST';
export const GET_DIST_CARD_PROFILE_SUCCESS = 'GET_DIST_CARD_PROFILE_SUCCESS';
export const GET_DIST_CARD_PROFILE_FAILURE = 'GET_DIST_CARD_PROFILE_FAILURE';

export const PDPA_GET_ORDER_DETAILS_REQUEST = 'PDPA_GET_ORDER_DETAILS_REQUEST';
export const PDPA_GET_ORDER_DETAILS_SUCCESS = 'PDPA_GET_ORDER_DETAILS_SUCCESS';
export const PDPA_GET_ORDER_DETAILS_FAILURE = 'PDPA_GET_ORDER_DETAILS_FAILURE';

export const TERMINATE_PARENT_SVC_NUM_REQUEST = 'TERMINATE_PARENT_SVC_NUM_REQUEST';
export const TERMINATE_PARENT_SVC_NUM_SUCCESS = 'TERMINATE_PARENT_SVC_NUM_SUCCESS';
export const TERMINATE_PARENT_SVC_NUM_FAILURE = 'TERMINATE_PARENT_SVC_NUM_FAILURE';

export const GET_SIM_CHARGE_REQUEST = 'GET_SIM_CHARGE_REQUEST';
export const GET_SIM_CHARGE_SUCCESS = 'GET_SIM_CHARGE_SUCCESS';
export const GET_SIM_CHARGE_FAILURE = 'GET_SIM_CHARGE_FAILURE';

export const GET_RESET_CARD_PROFILE = 'GET_RESET_CARD_PROFILE';

export const WAIVER_REQUEST_STATUS_UPDATE_REQUEST = 'WAIVER_REQUEST_STATUS_UPDATE_REQUEST';
export const WAIVER_REQUEST_STATUS_UPDATE_SUCCESS = 'WAIVER_REQUEST_STATUS_UPDATE_SUCCESS';
export const WAIVER_REQUEST_STATUS_UPDATE_FAILURE = 'WAIVER_REQUEST_STATUS_UPDATE_FAILURE';

export const GET_WAIVERED_ORDER_REQUEST = 'GET_WAIVERED_ORDER_REQUEST';
export const GET_WAIVERED_ORDER_SUCCESS = 'GET_WAIVERED_ORDER_SUCCESS';
export const GET_WAIVERED_ORDER_FAILURE = 'GET_WAIVERED_ORDER_FAILURE';

export const ORDER_SAVE_SMART_TEMPLATE_REQUEST = 'ORDER_SAVE_SMART_TEMPLATE_REQUEST';
export const ORDER_SAVE_SMART_TEMPLATE_SUCCESS = 'ORDER_SAVE_SMART_TEMPLATE_SUCCESS';
export const ORDER_SAVE_SMART_TEMPLATE_FAILURE = 'ORDER_SAVE_SMART_TEMPLATE_FAILURE';

export const SET_IS_SMART_TEMPLATE_FLOW = 'SET_IS_SMART_TEMPLATE_FLOW';

export const EDIT_SMART_TEMPLATE_REQUEST = 'EDIT_SMART_TEMPLATE_REQUEST';
export const EDIT_SMART_TEMPLATE_SUCCESS = 'EDIT_SMART_TEMPLATE_SUCCESS';
export const EDIT_SMART_TEMPLATE_FAILURE = 'EDIT_SMART_TEMPLATE_FAILURE';

export const SET_DELETE_SMART_TEMPLATE_ID = 'SET_DELETE_SMART_TEMPLATE_ID';

export const REFIT_LINE_SUBMIT_REQUEST = 'REFIT_LINE_SUBMIT_REQUEST';
export const REFIT_LINE_SUBMIT_SUCCESS = 'REFIT_LINE_SUBMIT_SUCCESS';
export const REFIT_LINE_SUBMIT_ERROR = 'REFIT_LINE_SUBMIT_ERROR';

export const PDPA_QR_IMAGE_RET_REQUEST = 'PDPA_QR_IMAGE_RET_REQUEST';
export const PDPA_QR_IMAGE_RET_SUCCESS = 'PDPA_QR_IMAGE_RET_SUCCESS';
export const PDPA_QR_IMAGE_RET_ERROR = 'PDPA_QR_IMAGE_RET_ERROR';

export const GET_BULK_ORDER_DETAILS_BY_ITEM_ID_REQUEST = "GET_BULK_ORDER_DETAILS_BY_ITEM_ID_REQUEST";
export const GET_BULK_ORDER_DETAILS_BY_ITEM_ID_SUCCESS = "GET_BULK_ORDER_DETAILS_BY_ITEM_ID_SUCCESS";
export const GET_BULK_ORDER_DETAILS_BY_ITEM_ID_ERROR = "GET_BULK_ORDER_DETAILS_BY_ITEM_ID_ERROR";